// Único umbral de longitud mínima de contraseña — front (PasswordField, minLength) y Worker
// (setup, signup, auth, platform-tenants) importan de aquí en vez de repetir el número.
export const MIN_PASSWORD_LENGTH = 8;

export const PASSWORD_TOO_SHORT_MESSAGE = `La contraseña debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres`;

export function isPasswordLongEnough(password: string): boolean {
  return password.length >= MIN_PASSWORD_LENGTH;
}
